import React, { useContext } from "react";
import { AppContext } from "../contexts/AppContext";
import { AuthContext } from "../contexts/AuthContext";
import axiosHttp from "../config/axios.interceptor";
import { errorResponseMessage } from "../shared/const.prop";

const ConfirmationAlert = ({ data = {} }) => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);

  const updateNoShow = async () => {
    try {
      const submitNoShow = await axiosHttp.post(
        `appointment/${data?.id}/no-show`
      );
      if (submitNoShow.status === 200) {
        appContext.updateNotificationState({
          show: true,
          message: "No show updated successfully",
          type: "success",
        });
        appContext.updateModalState();
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  return (
    <div>
      <div className="mt-4 mb-5">
        <div className=" d-flex justify-content-between align-items-center w-100 p-10 testimonials-wrapper">
          <p>{data?.description}</p>
        </div>
      </div>

      <div className=" mt-4 mb-5">
        <div className="mr-2 d-flex justify-content-end align-items-center w-100 p-10 testimonials-wrapper">
          <div>
            <button
              type="button"
              className="btn btn-outline-primary prime-btn mr-2"
              onClick={() => appContext.updateModalState()}
            >
              Cancel
            </button>
          </div>
          <div>
            <button
              type="button"
              className="btn btn-primary prime-btn"
              onClick={updateNoShow}
            >
              Yes, I understand
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationAlert;
